/* 
Handles issues when updating the api-base setting
by removing from localStorage the tradeinUuid
*/
(function checkIfApiBaseHasChanged() {
  if (localStorage.getItem('base_setting') !== global.apiBase) {
    //enters if setting.api_base has changed in the editor
    localStorage.removeItem('tradeinUuid')
    localStorage.setItem('base_setting', global.apiBase);
  }
})()